import { render } from "./TerminalsComponent.vue?vue&type=template&id=5be05788&scoped=true"
import script from "./TerminalsComponent.vue?vue&type=script&lang=js"
export * from "./TerminalsComponent.vue?vue&type=script&lang=js"

import "./TerminalsComponent.vue?vue&type=style&index=0&id=5be05788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be05788"]])

export default __exports__